/* THRESHOLD v2 — Site JavaScript */

(function () {
  'use strict';

  /* ── Scroll-triggered fade-up animations ──────────────────── */
  function initFadeUp() {
    const els = document.querySelectorAll('.fade-up');
    if (!els.length) return;

    const vh = window.innerHeight || document.documentElement.clientHeight;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -48px 0px' }
    );

    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      // Reveal elements already in the viewport immediately (LCP elements).
      // Prevents hero text LCP being blocked on IntersectionObserver latency.
      if (rect.top < vh && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
  }

  /* ── Sticky nav border on scroll ──────────────────────────── */
  function initNav() {
    const nav = document.querySelector('.nav');
    if (!nav) return;

    const onScroll = () => {
      nav.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile nav overlay ────────────────────────────────────── */
  function initMobileNav() {
    const hamburger = document.querySelector('.nav__hamburger');
    const overlay   = document.querySelector('.nav__mobile');
    const close     = document.querySelector('.nav__mobile-close');

    if (!hamburger || !overlay) return;

    hamburger.addEventListener('click', () => {
      overlay.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
    });

    const closeMenu = () => {
      overlay.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
    };

    if (close) close.addEventListener('click', closeMenu);

    overlay.querySelectorAll('.nav__link').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
  }

  /* ── Sticky purchase bar ───────────────────────────────────── */
  function initStickyBar() {
    const bar    = document.querySelector('.sticky-bar');
    const target = document.querySelector('[data-sticky-trigger]');
    if (!bar || !target) return;

    const observer = new IntersectionObserver(
      (entries) => {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }

  /* ── Gallery lightbox-lite ─────────────────────────────────── */
  function initGallery() {
    const strip  = document.querySelector('.gallery-strip');
    const main   = document.querySelector('[data-gallery-main]');
    if (!strip || !main) return;

    strip.querySelectorAll('.gallery-thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        strip.querySelectorAll('.gallery-thumb').forEach((t) => {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');

        const src   = thumb.dataset.src;
        const alt   = thumb.dataset.alt || '';
        const label = thumb.dataset.label || '';

        if (src) {
          main.innerHTML = `<img src="${src}" alt="${alt}" style="width:100%;height:100%;object-fit:cover;">`;
        } else {
          main.textContent = label || alt;
        }
      });
    });
  }

  /* ── Email form handling ───────────────────────────────────── */
  function initEmailForms() {
    document.querySelectorAll('form[data-email-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const input = form.querySelector('input[type="email"]');
        const btn   = form.querySelector('.lead-submit');
        const msg   = form.querySelector('[data-form-msg]');
        if (msg) {
          msg.textContent = "You're on the list. Check your inbox.";
          msg.style.color = 'var(--gold)';
        }
        if (btn) {
          btn.textContent = 'Sent.';
          btn.style.background = 'var(--gold-light)';
        }
        if (input) input.value = '';
      });
    });
  }

  /* ── Lead form — planner-aware button colour ───────────────── */
  function initLeadSelect() {
    const sel = document.querySelector('.lead-select');
    if (!sel) return;

    const accents = {
      vessel:  '#b89a6a',
      current: '#8e9aa6',
      shore:   '#8fa68e',
      tide:    '#a68e8e',
      anchor:  '#8ea6a0',
      still:   '#a69e8e',
      hold:    '#9a8ea6',
    };

    sel.addEventListener('change', () => {
      const btn = document.querySelector('.lead-submit');
      if (btn) btn.style.background = accents[sel.value] || 'var(--gold)';
    });
  }

  /* ── Scroll observer for premium components ────────────────── */
  function initScrollReveal() {
    const targets = document.querySelectorAll(
      '.fc, .rc, .bi, .planner-card, .pillar, .free-tool, .faq-item, .hero-planner-card'
    );
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    targets.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      observer.observe(el);
    });
  }

  /* ── Klaviyo popup trigger ─────────────────────────────────── */
  function triggerKlaviyoForm(formId) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  /* ── Waitlist buttons → Klaviyo popup WC4Nk9 ──────────────── */
  function initWaitlistModal() {
    document.querySelectorAll('[data-open-waitlist]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        triggerKlaviyoForm('WC4Nk9');
      });
    });
  }

  /* ── Free tool buttons → Klaviyo popup VbzWgS ─────────────── */
  function initFreeToolModal() {
    document.querySelectorAll('[data-open-freetool]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        triggerKlaviyoForm('VbzWgS');
      });
    });
  }

  /* ── Variant picker: PDF / HTML format selector ────────────── */
  function initVariantPicker() {
    const picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;

    picker.querySelectorAll('label[data-variant-id]').forEach(function (card) {
      card.addEventListener('click', function () {
        const variantId = card.dataset.variantId;
        const price     = card.dataset.variantPrice;

        // Update active card
        picker.querySelectorAll('label[data-variant-id]').forEach(function (c) {
          c.classList.remove('is-active');
        });
        card.classList.add('is-active');
        const radio = card.querySelector('.vp__radio');
        if (radio) radio.checked = true;

        // Sync all product form hidden inputs on the page
        document.querySelectorAll('[data-variant-input]').forEach(function (input) {
          input.value = variantId;
        });

        // Update price text in all buy buttons
        document.querySelectorAll('[data-price-display]').forEach(function (el) {
          el.textContent = price;
        });
      });
    });
  }

  /* ── Init ──────────────────────────────────────────────────── */
  // Script loads with defer — DOM is fully parsed when we run, no listener needed.
  initFadeUp();
  initNav();
  initMobileNav();
  initStickyBar();
  initGallery();
  initEmailForms();
  initLeadSelect();
  initScrollReveal();
  initWaitlistModal();
  initFreeToolModal();
  initVariantPicker();
})();

/* ── Global accordion functions (called via onclick attrs) ─────── */
window.toggleTier = function (header) {
  const body   = header.nextElementSibling;
  const toggle = header.querySelector('.bt-toggle');
  const isOpen = body.classList.contains('open');

  document.querySelectorAll('.bt-body').forEach((b) => b.classList.remove('open'));
  document.querySelectorAll('.bt-header').forEach((h) => h.classList.remove('open'));
  document.querySelectorAll('.bt-toggle').forEach((t) => {
    t.classList.remove('open');
    t.textContent = '+';
  });

  if (!isOpen) {
    body.classList.add('open');
    header.classList.add('open');
    toggle.classList.add('open');
  }
};

window.toggleFaq = function (q) {
  const a      = q.nextElementSibling;
  const isOpen = a.classList.contains('open');

  document.querySelectorAll('.faq-a').forEach((el) => el.classList.remove('open'));
  document.querySelectorAll('.faq-q').forEach((el) => el.classList.remove('open'));

  if (!isOpen) {
    a.classList.add('open');
    q.classList.add('open');
  }
};
